import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { ISchedule } from 'types/interfaces/ITypes'

interface ScheduleCacheState {
  scheduled: ISchedule[]
  lastFetched: number | null
  setScheduled: (scheduled: ISchedule[]) => void
  clear: () => void
}

export const useScheduleCacheStore = create<ScheduleCacheState>()(
  persist(
    (set) => ({
      scheduled: [],
      lastFetched: null,
      setScheduled: (scheduled) => set({ scheduled, lastFetched: Date.now() }),
      clear: () => set({ scheduled: [], lastFetched: null }),
    }),
    {
      name: 'schedule-cache',
      partialize: (state) => ({
        scheduled: state.scheduled,
        lastFetched: state.lastFetched,
      }),
    }
  )
)
